/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ChangeInputs */

const en_change = /** @type {(inputs: ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change`)
};

const es_change = /** @type {(inputs: ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio`)
};

/**
* | output |
* | --- |
* | "Change" |
*
* @param {ChangeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const change = /** @type {((inputs?: ChangeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ChangeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_change(inputs)
	return es_change(inputs)
});